<style scope></style>

<template>
  <div>

      <b-table :data="lista" :loading="loading" class="row-button"
               :paginated="true" :perPage="20" :narrowed="true" :striped="true">
        <portal-lista-vazia slot="empty"/>

        <template slot-scope="props">

          <b-table-column label="Pedido">
            {{ props.row.E3_PEDIDO }}
          </b-table-column>

          <b-table-column label="Cliente">
            {{ props.row.E3_CODCLI }}
          </b-table-column>

          <b-table-column label="Loja">
          {{ props.row.E3_LOJA }}
          </b-table-column>

          <b-table-column label="Nome do Cliente">
            {{ props.row.A1_NOME }}
          </b-table-column>

          <b-table-column label="Prefixo">
            {{ props.row.E3_PREFIXO }}
          </b-table-column>

          <b-table-column label="Número">
            {{ props.row.E3_NUM }}
          </b-table-column>

          <b-table-column label="Parcela">
            {{ props.row.E3_PARCELA }}
          </b-table-column>

          <b-table-column label="Emissao" >
            {{ props.row.E1_EMISSAO | moment("DD/MM/YYYY") }}
          </b-table-column>

          <b-table-column label="Vencimento" >
            {{ props.row.E3_VENCREA | moment("DD/MM/YYYY") }}
          </b-table-column>

          <b-table-column label="Liquidação" >
            {{ props.row.E3_BAIXA | moment("DD/MM/YYYY") }}
          </b-table-column>

          <b-table-column label="Vlr. Base">
            {{ props.row.E3_BASE | moeda }}
          </b-table-column>

          <b-table-column label="%">
            {{ props.row.E3_PORC }}
          </b-table-column>

          <b-table-column label="Vlr. Comissão">
            {{ props.row.E3_COMIS | moeda }}
          </b-table-column>
        </template>

        <template slot="footer">
          <div class="has-text-right">

            <div class="columns">
              <div class="column p-b-0">
                Total:
              </div>
              <div class="column is-1 p-b-0">
                {{valorTotal | moeda}}
              </div>
            </div>
          </div>
        </template>

      </b-table>

  </div>
</template>

<script>
  export default {
    props: ['lista', 'loading', 'valorTotal']
  }
</script>



// WEBPACK FOOTER //
// src/pages/comissao/ListaComissaoAnalitica.vue